module.exports = __webpack_public_path__ + "img/31.801c8c6e.png";